"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Annotations_1 = require("./Annotations");
var image_1 = require("../../shared/models/image");
var ImagePreviews_1 = require("../../shared/components/ImagePreviews");
var settings_1 = require("../../shared/util/settings");
var LargeScreenTooltip_1 = require("./LargeScreenTooltip");
var PreviewPosition;
(function (PreviewPosition) {
    PreviewPosition["DOWN"] = "down";
    PreviewPosition["RIGHT"] = "right";
    PreviewPosition["LEFT"] = "left";
})(PreviewPosition = exports.PreviewPosition || (exports.PreviewPosition = {}));
var anyWindow = window;
var ImageSlider = /** @class */ (function (_super) {
    __extends(ImageSlider, _super);
    function ImageSlider(props) {
        var _this = _super.call(this, props) || this;
        _this.currentImage = function () {
            return _this.props.images[_this.props.imageIndex];
        };
        _this.showNextImage = function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            _this.setState({ zooming: false, previousImage: _this.currentImage() });
            _this.props.nextImage();
        };
        _this.showPreviousImage = function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            _this.setState({ zooming: false, previousImage: _this.currentImage() });
            _this.props.previousImage();
        };
        _this.showGraphics = function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            _this.props.showGraphics();
        };
        _this.hideGraphics = function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            _this.props.hideGraphics();
        };
        _this.showSizeChart = function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            _this.props.showSizeChartAction();
        };
        _this.toggleDisplayUnits = function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            _this.props.toggleDisplayUnit();
        };
        _this.renderNormalActions = function (zIndex, opacity, hasAnnotations, hasMeasurements) {
            var _a = _this, showGraphics = _a.showGraphics, showSizeChart = _a.showSizeChart;
            var _b = _this.props, canToggleGraphics = _b.canToggleGraphics, canToggleSizeChart = _b.canToggleSizeChart, largeScreen = _b.largeScreen;
            var showText = settings_1.showButtonText();
            var showMargin = showText ? "10px" : "0";
            var toggleMeasureHTML;
            if (canToggleGraphics && hasAnnotations) {
                var showMeasurementsCopy = anyWindow
                    && anyWindow.measuredApp
                    && anyWindow.measuredApp.showMeasurementsCopy
                    || "Show measurements";
                toggleMeasureHTML =
                    React.createElement(LargeScreenTooltip_1.LargeScreenTooltip, { placement: "left", overlay: showMeasurementsCopy, largeScreen: largeScreen },
                        React.createElement("a", { className: "ma-measurement ma-action-button", href: "#", onClick: showGraphics, style: { zIndex: zIndex, opacity: opacity } },
                            React.createElement("i", { className: "fas fa-ruler", style: { marginBottom: showMargin } }),
                            showText ?
                                React.createElement("div", { className: "ma-action-button-label" }, "Show")
                                : null));
            }
            var toggleSizeChartHTML;
            if (canToggleSizeChart && hasMeasurements) {
                var toggleSizeChartOverlayCopy = anyWindow
                    && anyWindow.measuredApp
                    && anyWindow.measuredApp.toggleSizeChartOverlayCopy
                    || "Size Chart";
                toggleSizeChartHTML =
                    React.createElement(LargeScreenTooltip_1.LargeScreenTooltip, { placement: "left", overlay: toggleSizeChartOverlayCopy, largeScreen: largeScreen },
                        React.createElement("a", { className: "ma-size-chart ma-action-button", href: "#", onClick: showSizeChart, style: { zIndex: zIndex, opacity: opacity } },
                            React.createElement("i", { className: "fas " + settings_1.sizeChartIcon(), style: { marginBottom: showMargin } }),
                            showText ?
                                React.createElement("div", { className: "ma-action-button-label" }, "Chart")
                                : null));
            }
            return React.createElement("div", { className: "ma-action-button-group", style: { zIndex: zIndex } },
                toggleMeasureHTML,
                toggleSizeChartHTML);
        };
        _this.renderMeasurementActions = function (zIndex) {
            var _a = _this, hideGraphics = _a.hideGraphics, toggleDisplayUnits = _a.toggleDisplayUnits;
            var _b = _this.props, canToggleGraphics = _b.canToggleGraphics, canToggleDisplayUnit = _b.canToggleDisplayUnit, displayUnit = _b.displayUnit, largeScreen = _b.largeScreen;
            var hideMeasurementsHTML;
            if (canToggleGraphics) {
                var hideMeasurementsCopy = anyWindow
                    && anyWindow.measuredApp
                    && anyWindow.measuredApp.hideMeasurementsCopy
                    || "Hide measurements";
                hideMeasurementsHTML =
                    React.createElement(LargeScreenTooltip_1.LargeScreenTooltip, { placement: "left", overlay: hideMeasurementsCopy, largeScreen: largeScreen },
                        React.createElement("a", { className: "ma-measurement-cancel ma-action-button", href: "#", onClick: hideGraphics, style: { zIndex: zIndex } },
                            React.createElement("i", { className: "fas fa-times" })));
            }
            var toggleDisplayUnitsHTML;
            if (canToggleDisplayUnit) {
                var toggleDisplayUnitsOverlay = anyWindow
                    && anyWindow.measuredApp
                    && anyWindow.measuredApp.toggleDisplayUnitsOverlayCopy
                    || "Click to change units";
                toggleDisplayUnitsHTML =
                    React.createElement(LargeScreenTooltip_1.LargeScreenTooltip, { placement: "left", overlay: toggleDisplayUnitsOverlay, largeScreen: largeScreen },
                        React.createElement("a", { className: "ma-size-unit ma-action-button", href: "#", onClick: toggleDisplayUnits, style: { zIndex: zIndex } }, "cm / in"));
            }
            var measurementActionsHTML = (React.createElement("div", { className: "ma-action-button-group", style: { zIndex: zIndex } },
                hideMeasurementsHTML,
                toggleDisplayUnitsHTML));
            return measurementActionsHTML;
        };
        _this.renderActionButtonGroup = function (zIndex) {
            var _a = _this.props, displayVariantId = _a.displayVariantId, annotationsDisplay = _a.annotationsDisplay, toggleActionButtonsOnHover = _a.toggleActionButtonsOnHover, graphics = _a.graphics, sizeChart = _a.sizeChart;
            var hover = _this.state.hover;
            var opacity = 1;
            if (toggleActionButtonsOnHover) {
                if (hover) {
                    opacity = 1;
                }
                else {
                    opacity = 0.75;
                }
            }
            var currentImage = _this.currentImage();
            var currentGraphics = graphics.graphics[currentImage.shopifyImageId] || [];
            var graphicDimensionKeys = currentGraphics.map(function (g) { return g.dimensionKey; });
            var hasGraphicMeasurements = sizeChart.measurements.some(function (m) {
                var hasRelevantDimensionKey = graphicDimensionKeys.some(function (dimensionKey) { return dimensionKey === m.dimensionKey; });
                var hasRelevantVariantId = m.variantId === displayVariantId;
                return hasRelevantDimensionKey && hasRelevantVariantId;
            });
            var hasGraphics = currentGraphics.length > 0;
            var hasMeasurements = sizeChart.measurements.length > 0;
            if (annotationsDisplay === Annotations_1.AnnotationsDisplay.HIDE) {
                return _this.renderNormalActions(zIndex, opacity, hasGraphics && hasGraphicMeasurements, hasMeasurements);
            }
            else if (hasGraphics) {
                return _this.renderMeasurementActions(zIndex);
            }
            return _this.renderNormalActions(zIndex, opacity, hasGraphics && hasGraphicMeasurements, hasMeasurements);
        };
        _this.renderAnnotations = function (featuredImage, zIndex) {
            var _a = _this.props, graphics = _a.graphics, sizeChart = _a.sizeChart, displayUnit = _a.displayUnit, displayVariantId = _a.displayVariantId, annotationsDisplay = _a.annotationsDisplay;
            var featuredImageAnnotations = graphics.graphics[featuredImage.shopifyImageId] || [];
            return React.createElement("div", { style: { zIndex: zIndex } },
                React.createElement(Annotations_1.Annotations, { graphics: featuredImageAnnotations, sizingChart: sizeChart, displayState: annotationsDisplay, displayUnit: displayUnit, currentVariantId: displayVariantId, dimensions: graphics.dimensionOrder }));
        };
        _this.renderFeaturedImageTag = function (featuredImage, imageMaxDimension) {
            var _a = _this.state, zooming = _a.zooming, zoomLeft = _a.zoomLeft, zoomTop = _a.zoomTop, syntheticHeight = _a.syntheticHeight, syntheticWidth = _a.syntheticWidth;
            var opacity = zooming ? 1 : 0; // NOTE(jeffk): for preloading
            var display = zooming ? "block" : "none";
            var annotationsShown = !_this.canToggleImageZoom();
            var position = annotationsShown ? undefined : "relative";
            var imageDimensionStyle = imageMaxDimension ?
                { maxWidth: imageMaxDimension, maxHeight: imageMaxDimension }
                : {};
            var showImageStyle = _this.state.hideLoader ? {} : { display: "none" };
            var featuredImageZoomStyle = _this.state.zooming ? { opacity: 0 } : {};
            var imagePlaceholder = React.createElement("div", { className: "ma-image-load" },
                React.createElement("img", { src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==", width: featuredImage.shopifyWidth ? featuredImage.shopifyWidth : 2048, height: "auto" }));
            return React.createElement("div", { style: { position: position, overflow: "hidden" } },
                React.createElement("div", { className: "ma-featured-zoom-wrapper", style: { display: display } },
                    React.createElement("img", { src: featuredImage.mainURL, className: "ma-featured-zoom", ref: _this.zoomImageRef, style: {
                            top: zoomTop,
                            left: zoomLeft,
                            height: syntheticHeight,
                            width: syntheticWidth,
                            opacity: opacity,
                            transition: "opacity 200ms ease-in 0s",
                        } })),
                React.createElement("img", { src: featuredImage.mainURL, className: "ma-featured", ref: _this.featuredImageRef, key: "ma-featured-" + featuredImage.shopifyImageId, srcSet: image_1.sourceSetString(featuredImage.mainURL, featuredImage.srcSet), style: __assign({}, imageDimensionStyle, showImageStyle, featuredImageZoomStyle), onLoad: function () { return _this.hideLoader(true); } }),
                _this.props.showExpiredNotice ?
                    React.createElement("div", { className: "ma-expiry-notice" },
                        React.createElement("a", { href: "https://getmeasured.app", target: "_blank" }, "Your trial of Measured has expired."))
                    : null,
                _this.state.hideLoader ? undefined : imagePlaceholder);
        };
        _this.setHoverFn = function (hover) {
            if (!hover) {
                return _this.setState({ hover: hover, zooming: false });
            }
            _this.setState({ hover: hover });
        };
        _this.recordMouseMove = function (ev) {
            var rect = ev.currentTarget.getBoundingClientRect();
            if (_this.zoomImageRef.current && _this.featuredImageRef.current) {
                var x = ev.clientX - rect.left;
                var y = ev.clientY - rect.top;
                var zoomImg = _this.zoomImageRef.current;
                var img = _this.featuredImageRef.current;
                var syntheticZoomRatio = settings_1.zoomLevel();
                var syntheticHeight = img.clientHeight * syntheticZoomRatio;
                var syntheticWidth = img.clientWidth * syntheticZoomRatio;
                var zoomWidth = (syntheticWidth || zoomImg.naturalWidth);
                var zoomHeight = (syntheticHeight || zoomImg.naturalHeight);
                var width = rect.width;
                var height = rect.height;
                var widthMultiplier = zoomWidth / width;
                var heightMultiplier = zoomHeight / height;
                var zoomCenterX = x * widthMultiplier;
                var zoomCenterY = y * heightMultiplier;
                var zoomLeft = -(zoomCenterX - width / 2);
                var zoomTop = -(zoomCenterY - height / 2);
                var zoomLeftBound = width - zoomWidth;
                var zoomTopBound = height - zoomHeight;
                _this.setState({
                    zoomLeft: Math.min(0, Math.max(zoomLeft, zoomLeftBound)),
                    zoomTop: Math.min(0, Math.max(zoomTop, zoomTopBound)),
                    syntheticHeight: syntheticHeight,
                    syntheticWidth: syntheticWidth,
                });
            }
        };
        _this.renderFeaturedImage = function (featuredImage) {
            var _a = _this, showNextImage = _a.showNextImage, showPreviousImage = _a.showPreviousImage, setHoverFn = _a.setHoverFn;
            var zooming = _this.state.zooming;
            var _b = _this.props, images = _b.images, imageMaxDimension = _b.imageMaxDimension, enableSliderArrows = _b.enableSliderArrows;
            var annotationsZ = 1000;
            var actionButtonsZ = 1001;
            var toggleImageZ = 1002;
            var imageAnnotationsHTML = React.createElement("div", null,
                _this.renderAnnotations(featuredImage, annotationsZ),
                _this.renderFeaturedImageTag(featuredImage, imageMaxDimension));
            var showActionButtons = !zooming;
            var nextImageHTML;
            var prevImageHTML;
            if (images.length > 1 && enableSliderArrows) {
                nextImageHTML =
                    React.createElement("a", { className: "ma-slide-next ma-toggle-image", href: "#", onClick: showNextImage, style: { zIndex: toggleImageZ } },
                        React.createElement("i", { className: "fa fa-chevron-right", "aria-hidden": "true" }));
                prevImageHTML =
                    React.createElement("a", { className: "ma-slide-prev ma-toggle-image", href: "#", onClick: showPreviousImage, style: { zIndex: toggleImageZ } },
                        React.createElement("i", { className: "fa fa-chevron-left", "aria-hidden": "true" }));
            }
            var imageZoomCursor;
            if (_this.canToggleImageZoom()) {
                if (_this.state.zooming) {
                    imageZoomCursor = "ma-zoom-out";
                }
                else {
                    imageZoomCursor = "ma-zoom-in";
                }
            }
            return React.createElement("div", { className: "ma-featured-image-container" },
                React.createElement("div", { className: "ma-featured-image " + (imageZoomCursor || ""), onClick: _this.maybeToggleImageZoom, onMouseEnter: function () { return setHoverFn(true); }, onMouseLeave: function () {
                        setHoverFn(false);
                    }, onMouseMove: _this.recordMouseMove },
                    showActionButtons ? _this.renderActionButtonGroup(actionButtonsZ) : null,
                    zooming ? undefined : nextImageHTML,
                    zooming ? undefined : prevImageHTML,
                    imageAnnotationsHTML));
        };
        _this.canToggleImageZoom = function () {
            var zoomable = _this.props.zoomable;
            var featuredImageRendered = _this.featuredImageRef.current !== null;
            var noAnnotations = _this.props.annotationsDisplay === Annotations_1.AnnotationsDisplay.HIDE;
            return zoomable && featuredImageRendered && noAnnotations;
        };
        _this.maybeToggleImageZoom = function () {
            if (!_this.canToggleImageZoom()) {
                return;
            }
            var zooming = _this.state.zooming;
            _this.setState({ zooming: !zooming });
        };
        _this.hideLoader = function (hide) {
            _this.setState({ hideLoader: hide });
        };
        _this.featuredImageRef = React.createRef();
        _this.zoomImageRef = React.createRef();
        _this.state = {
            previousImage: undefined,
            hover: false,
            zooming: false,
            zoomLeft: 0,
            zoomTop: 0,
            syntheticHeight: undefined,
            syntheticWidth: undefined,
            hideLoader: false,
        };
        return _this;
    }
    ImageSlider.prototype.render = function () {
        var _a = this.props, images = _a.images, imageIndex = _a.imageIndex, showImagePreviews = _a.showImagePreviews, selectImage = _a.selectImage, imagePreviewPosition = _a.imagePreviewPosition;
        var featuredImageHTML = React.createElement("div", { className: "ma-no-images" });
        if (images.length > 0) {
            var featuredImage = this.currentImage();
            featuredImageHTML = this.renderFeaturedImage(featuredImage);
        }
        var flexClass = "ma-flex-column";
        switch (imagePreviewPosition) {
            case PreviewPosition.RIGHT:
                flexClass = "ma-flex-row";
                break;
            case PreviewPosition.LEFT:
                flexClass = "ma-flex-row-reverse";
                break;
            case PreviewPosition.DOWN:
            default:
                flexClass = "ma-flex-column";
                break;
        }
        var isHorizontal = imagePreviewPosition === PreviewPosition.DOWN;
        var previewDirection = isHorizontal ? ImagePreviews_1.PreviewDirection.ROW : ImagePreviews_1.PreviewDirection.COLUMN;
        var imagePreviewHTML = React.createElement(ImagePreviews_1.ImagePreviews, { images: images, imageIndex: imageIndex, showImageAtIndex: selectImage, direction: previewDirection });
        return (React.createElement("div", { className: "ma-slider " + flexClass },
            featuredImageHTML,
            showImagePreviews ? imagePreviewHTML : undefined));
    };
    return ImageSlider;
}(React.PureComponent));
exports.default = ImageSlider;
